import script from "./MakePledge.vue?vue&type=script&setup=true&lang=js"
export * from "./MakePledge.vue?vue&type=script&setup=true&lang=js"

import "./MakePledge.vue?vue&type=style&index=0&id=1865317d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1865317d"]])

export default __exports__